import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=d59044e2&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=d59044e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBreadcrumb: require('/opt/build/repo/components/UI/Breadcrumb.vue').default,UIClearPay: require('/opt/build/repo/components/UI/ClearPay.vue').default,CoursesPurchaseButton: require('/opt/build/repo/components/Courses/PurchaseButton.vue').default,UIReviewsAlt: require('/opt/build/repo/components/UI/ReviewsAlt.vue').default})
